module.exports = {"pagination":{"ListChannels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasetContents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatastores":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/iotanalytics-2017-11-27.paginators.json
// module id = 523
// module chunks = 30